export enum CountRangesEnum {
    One = '1',
    Two = '2',
    Three = '3',
    Four = '4',
    Five = '5',
    Six = '6',
    Seven = '7',
    Eight = '8',
    Nine = '9',
    Ten = '10',
    Eleven = '11',
    Twelve = '12',
    Thirteen = '13',
    Fourteen = '14',
    Fifteen = '15',
    Sixteen = '16',
    Seventeen = '17',
    Eighteen = '18',
    Nineteen = '19',
    Twenty = '20',
    TwentyOne = '21',
    TwentyTwo = '22',
    TwentyThree = '23',
    TwentyFour = '24',
    TwentyFive = '25',
    TwentySix = '26',
    TwentySeven = '27',
    TwentyEightToThirty = '28-30',
    ThirtyOne = '31',
    ThirtyTwo = '32',
    ThirtyThreeToThirtyFive = '33-35',
    ThirtySixToForty = '36-40',
    FortyOne = '41',
    FortyTwo = '42',
    FortyThreeToFortyFive = '43-45',
    FortySixToFifty = '46-50',
    FiftyOne = '51',
    FiftyTwo = '52',
    FiftyThreeToSixty = '53-60',
    SixtyOne = '61',
    SixtyTwo = '62',
    SixtyThreeToSeventy = '63-70',
    SeventyOne = '71',
    SeventyTwo = '72',
    SeventyThreeToEighty = '73-80',
    EightyOne = '81',
    EightyTwo = '82',
    EightyThreeToNinety = '83-90',
    NinetyOne = '91',
    NinetyTwo = '92',
    NinetyThreeToHundred = '93-100',
    HundredOneToHundredTen = '101-110',
    HundredElevenToHundredTwenty = '111-120',
    HundredTwentyOneToHundredThirty = '121-130',
    HundredThirtyAbove = '130 above',
}